import { useEffect } from 'react'
import { toast } from 'react-toastify'

import { useAsync } from 'core/ui/hooks/useAsync'

import { SHIPPER_DETAIL_DRAWER_TOAST_ID } from '../ui/shipper-detail-drawer/ShipperDetailDrawer'
import { deleteShipperAttachment } from '../use-cases/deleteShipperAttachment'

type UseDeleteShipperAttachmentParams = {
  onSuccess?: () => void
}

export function useDeleteShipperAttachment({ onSuccess }: UseDeleteShipperAttachmentParams = {}) {
  const { call, isPending, isDone, hasError, reset } = useAsync(deleteShipperAttachment)

  useEffect(() => {
    if (!isDone) return
    onSuccess?.()
    toast.success('Document deleted successfully', { containerId: SHIPPER_DETAIL_DRAWER_TOAST_ID })
    reset()
  }, [isDone, onSuccess, reset])

  useEffect(() => {
    if (!hasError) return
    toast.error('Failed to delete document', { containerId: SHIPPER_DETAIL_DRAWER_TOAST_ID })
    reset()
  }, [hasError, reset])

  return { deleteAttachment: call, isDeleting: isPending }
}
